export default __webpack_public_path__ + "static/need-help-355e30c45c42b0e56f2d96b5151d97a6.webp";